import { Component, OnInit, Input, OnChanges, ElementRef, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { DialogService } from 'primeng/dynamicdialog';

import { HelperService, HTTPService } from 'app/services';
import { ProcedureDiagramDialogComponent } from 'app/modules/app-components/procedure-diagram-dialog/procedure-diagram-dialog.component';

@Component({
  selector: 'app-rd-procedures',
  templateUrl: './rd-procedures.component.html',
  styleUrls: ['./rd-procedures.component.scss'],
  providers: [DialogService],
})
export class RdProceduresComponent implements OnInit, OnChanges, OnDestroy {
  @Input() options: any = {};
  @Input() vehicleId: string = '';
  @Input() procedures: any[] = [];
  @Input() isProcessing: boolean = false;

  htmlProcedure: any = '';
  images: any[] = [];
  isLoading: boolean = false;
  isProceduresSelected: boolean = false;
  selectedProcedures: any = {};
  config = {
    btnClass: 'default',
    zoomFactor: 0.1,
    containerBackgroundColor: '#ccc',
    wheelZoom: true,
    allowFullscreen: true,
    allowKeyboardNavigation: true,
    btnIcons: {
      zoomIn: 'fal fa-search-plus',
      zoomOut: 'fal fa-search-minus',
      next: 'fas fa-caret-right',
      prev: 'fas fa-caret-left',
      fullscreen: 'fal fa-expand',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      next: true,
      prev: true,
    },
  };
  timeOutRef: any;
  selectedProcedure: any = {};

  constructor(private elementRef: ElementRef, private dialogService: DialogService, private httpService: HTTPService, private helperService: HelperService, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.fetchInitialDetails();
  }

  ngOnDestroy(): void {
    this._clearTimeout();
  }

  ngOnChanges(change: any) {
    const { isProcessing } = change;
    if (isProcessing) {
      if (isProcessing.previousValue && !isProcessing.currentValue) {
        this.fetchInitialDetails();
      }
    }
  }

  _clearTimeout() {
    if (this.timeOutRef) {
      try {
        clearTimeout(this.timeOutRef);
      } catch (err) {
        console.log(err);
      }
    }
  }

  openFigureDialog(image: any) {
    this.dialogService.open(ProcedureDiagramDialogComponent, {
      showHeader: false,
      styleClass: 'repair-diagram-dialog-ref',
      data: { title: this.selectedProcedures.displayName, images: this.images, currentImage: image },
    });
  }

  fetchInitialDetails() {
    if (this.isLoading) return;

    if (this.procedures.length) {
      this.selectedProcedure = this.procedures[0];
      this.getProceduresDetails(this.procedures[0]);
    }
  }

  getProceduresDetails = (procedure: any) => {
    this.isLoading = true;
    this.htmlProcedure = '';
    this.selectedProcedures = { ...procedure };
    this._clearTimeout();
    this.httpService
      .getProceduresDetail({
        ...this.options,
        vehicleId: this.vehicleId,
        applicationId: procedure.applicationId,
      })
      .then(
        ({ procedure }) => {
          if (procedure) {
            this.htmlProcedure = procedure.data;
            this.images = procedure.images;
            this.htmlProcedure = this.htmlProcedure.replaceAll('<stepgrp>', '<ol>');
            this.htmlProcedure = this.htmlProcedure.replaceAll('</stepgrp>', '</ol>');
            this.htmlProcedure = this.htmlProcedure.replaceAll('<step>', '<li>');
            this.htmlProcedure = this.htmlProcedure.replaceAll('</step>', '</li>');

            this.images.forEach(({ name }, index) => {
              this.htmlProcedure = this.htmlProcedure.replace(
                new RegExp(`<emph type="bold">Fig.*\\s<xref idref="${name.toLowerCase()}"*\\s/>[,.]*</emph>`, 'i'),
                `<span id="fig-${index}" class="font-primary pointer text-underline">Fig. ${index + 1}</span>`
              );
            });
            this.htmlProcedure = this.sanitizer.bypassSecurityTrustHtml(this.htmlProcedure) as string;

            this.timeOutRef = setTimeout(() => {
              this.images.forEach((image, index) => {
                const el = this.elementRef.nativeElement.querySelector(`#fig-${index}`);
                if (el) {
                  el.addEventListener('click', () => {
                    this.openFigureDialog(image);
                  });
                }
              });
            }, 1000);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  };

  handleBack() {}
}
